import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  useMediaQuery,
  useTheme,
} from "@mui/material";

function DialogVehicleModel(props) {
  const { open, handleClose, handleAgree, vehicle } = props;
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullScreen={fullScreen}
    >
      {vehicle?.availability == false ? (
        <div>
          <DialogTitle id="alert-dialog-title">
            {"Deleting Way Points"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description" style={{color:'red'}}>
              This Vehicle can't delete because {vehicle?.vehicleType} already assigned to a schedule
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} autoFocus>
              Skip
            </Button>
          </DialogActions>
        </div>
      ) : (
        <div>
          <DialogTitle id="alert-dialog-title">
            {"Deleting Way Points"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Deletion Need Admin Approval, Are You Sure you Need To Delete {vehicle?.vehicleType}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleAgree}>Yes</Button>
            <Button onClick={handleClose} autoFocus>
              No
            </Button>
          </DialogActions>
        </div>
      )}
    </Dialog>
  );
}

export default DialogVehicleModel;
